<script>

// COMMANDS:
// Shift + D = Show/Hide toolbar and stats
// Shift + B = Show/Hide element boundaries
// Shift + S = Show/Hide stats

// TO DO:
// - [x] Refactor stats using {#each} blocks
// - [x] [ low pri ] fix header, footer, body dimension tracking

    import { onMount } from 'svelte';
    import { 
        viewport, 
        sections, 
		components

    } from '$lib/stores/shared.svelte.js';
    import '$css';

    const stats = $derived([
        {key: 'vW:', value: viewport.vw + 'px' },
        {key: 'vH:', value: viewport.vh + 'px' },
        {key: 'scroll X:', value: viewport.scrollX + 'px' },
        {key: 'scroll Y:', value: viewport.scrollY + 'px' },
        {key: 'nav width:', value: components.navW + 'px' },
        {key: 'nav open:', value: components.navOpen },
        {key: 'header height:', value: components.headH + 'px' },
        {key: 'footer height:', value: components.footH + 'px' },
        {key: 'section total:', value: sections.total },
        {key: 'section current:', value: sections.current },
        {key: 'section heights:', value: sections.heights },
    ]);

//  -- USE THIS INSTEAD OF AN IMPORTED { viewport } DATASET -- 
//     export const viewport = $state({
//     vh: 0,
//     vw: 0,
//     scrollY: 0,
//     scrollX: 0,
//     headH: 0,
//     footH: 0,
//     mainH: 0,
// });

    let showDebug = $state(false);
    let showBoundaries = $state(false);
    let showStats = $state(true);
    // let headerElementH = $state(null);
	// let footerElementH = $state(null);
    let navW = $state(0);
	let headerH = $state(0);
	let footerH = $state(0);
	let minMainH = $derived( viewport.vh - ( headerH + footerH) );

function handleKeydown(event) {
    // Prevent the action if an input is focused
    if (document.activeElement.tagName === 'INPUT') {
      return;
    };
    if (event.shiftKey && event.key === 'B') {
            showBoundaries = !showBoundaries;
    };
    if (event.shiftKey && event.key === 'D') {
            showDebug = !showDebug;
    };
    if (event.shiftKey && event.key === 'S') {
            showStats = !showStats;
    };
  };

//   function updateHeights() {
// 		headerH = headerElementH?.offsetHeight || 0;
// 		footerH = footerElementH?.offsetHeight || 0;
// 	};
</script>
<svelte:window 
    on:keydown|preventDefault={handleKeydown}
	/>

{#if showDebug}    
    {#if showStats}
    <!------ Debug Stats ------>
    <div class="stats f-row">
        <div class=" f-col text-r">
            {#each stats as stat(stat.key)}
                <span>{stat.key}</span> 
            {/each}
        </div>
        <div class="w-52 f-col text-r align-e text-blue">
            {#each stats as stat(stat.key)}
                <span>{stat.value}</span>
            {/each}
        </div>
        </div>
    {/if}

    <div class="debug-menu f-row gap-20">
        <!------ Toggle Stats ------>
        <button class="debug-button" onclick={() => showStats = !showStats} aria-label="toggle stats">
            <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="0.93335" y1="0.5" x2="8.40002" y2="0.5" stroke="currentColor"/>
                <line x1="10.2666" y1="0.5" x2="12.2666" y2="0.5" stroke="currentColor"/>
                <line x1="-4.37114e-08" y1="4.5" x2="8.4" y2="4.5" stroke="currentColor"/>
                <line x1="10.2666" y1="4.5" x2="12.2666" y2="4.5" stroke="currentColor"/>
                <line x1="3.7334" y1="8.5" x2="8.40007" y2="8.5" stroke="currentColor"/>
                <line x1="10.2666" y1="8.5" x2="12.2666" y2="8.5" stroke="currentColor"/>
            </svg>    
        </button>

        <!------ Toggle Element Boundaries ------>
        <button class="debug-button" onclick={() => showBoundaries = !showBoundaries} aria-label="toggle element boundaries">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 7V1H7" stroke="currentColor"/>
                <path d="M9 3L9 9L3 9" stroke="currentColor"/>
            </svg>
        </button>
    </div>    
{/if}
<style>
div, button {
    color: limegreen;
    z-index: 999;
}

button {
    background: none;
}

.stats, .debug-menu {
    z-index: 999;
    position: fixed;
	bottom: 0;
	right: 0;
}

.stats {
	margin: 4rem 1rem;
	font-size: .875rem;
	color: magenta;
	gap: .375rem;
}

.debug-menu {
    margin: 1rem 1rem;
}

.debug-button {
    cursor: pointer;
    width: 2.25rem;
    height: 2.25rem;
    padding: .375rem;
    background-color: none;
    border: none;
    border-radius: .5rem;
    transition: all 0.3s ease-in-out;
}

.debug-button:hover {
    transform: translateY(-.125rem);
    box-shadow: 0 .125rem .75rem 0 #909090;
    transition: all .3s ease-in-out;
}

.debug-button:active {
    transform: translateY(.125rem);
    box-shadow: inset .125rem .125rem .25rem 0 #909090;
}

.debug-button svg {
    width: 100%;
    height: 100%;
    background-color: none;
    object-fit: contain;
}

</style>

{#if showBoundaries}
	<style>
		* {
			box-sizing: border-box;
			box-shadow: 0 0 0 1px magenta !important;
		}
	</style>
{/if}
